<sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true" class="station-details" *ngIf="selection?.station != null">
    <div class="tab-group">
        <sc-flex>
            <ng-container *ngIf="selection.station.stationUsage.transports?.length !== 0">
                <div class="tab" [ngClass]="{'selected' : selectedTab === 'details'}" (click)="selectTab('details')">
                    <sc-flex>
                        <sc-icon iconClass="fa-truck"></sc-icon>
                        <ng-container *ngIf="selectedTab === 'details'">
                            <sc-content-spacer [half]="true"></sc-content-spacer>
                            Details
                        </ng-container>
                    </sc-flex>
                </div>
                <div class="tab" [ngClass]="{'selected' : selectedTab === 'tasks'}" (click)="selectTab('tasks')">
                    <sc-flex>
                        <sc-icon iconClass="fa-list-check"></sc-icon>
                        <ng-container *ngIf="selectedTab === 'tasks'">
                            <sc-content-spacer [half]="true"></sc-content-spacer>
                            Aufgaben
                        </ng-container>
                    </sc-flex>
                </div>
                <div class="tab" [ngClass]="{'selected' : selectedTab === 'actions'}" (click)="selectTab('actions')">
                    <sc-flex>
                        <sc-icon iconClass="fa-gears"></sc-icon>
                        <ng-container *ngIf="selectedTab === 'actions'">
                            <sc-content-spacer [half]="true"></sc-content-spacer>
                            Aktionen
                        </ng-container>
                    </sc-flex>
                </div>
                <div class="tab" [ngClass]="{'selected' : selectedTab === 'documents'}"
                    (click)="selectTab('documents')">
                    <sc-flex>
                        <sc-icon iconClass="fa-file"></sc-icon>
                        <ng-container *ngIf="selectedTab === 'documents'">
                            <sc-content-spacer [half]="true"></sc-content-spacer>
                            Dokumente
                        </ng-container>
                    </sc-flex>
                </div>
            </ng-container>
            <div class="tab" *ngIf="selection.station.stationUsage.transports?.length === 0">
                <sc-flex>
                    <sc-icon iconClass="fa-truck"></sc-icon>
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    verfügbare Transporte
                </sc-flex>
            </div>
        </sc-flex>
    </div>
    <sc-flex-fitting-content [vertical]="true">
        <app-sac-mobile-transport-details [station]="selection.station"
            *ngIf="selection.station.stationUsage.transports?.length !== 0 && selectedTab==='details'"></app-sac-mobile-transport-details>
        <app-task-position-details [transportId]="selection.station.stationUsage.transports[0].id"
            *ngIf="selection.station.stationUsage.transports?.length !== 0 && selectedTab==='tasks'"></app-task-position-details>
        <app-sac-mobile-transport-actions [station]="selection.station" [stationSet]="selection.stationSet"
            *ngIf="selection.station.stationUsage.transports?.length !== 0 && selectedTab==='actions'"></app-sac-mobile-transport-actions>
        <app-sac-mobile-transport-documents [station]="selection.station"
            *ngIf="selection.station.stationUsage.transports?.length !== 0 && selectedTab==='documents'"></app-sac-mobile-transport-documents>
        <sc-padding *ngIf="selection.station.stationUsage.transports?.length === 0" [fitHeight]="true">
            <app-sac-transports [selection]="selection">
            </app-sac-transports>
        </sc-padding>
    </sc-flex-fitting-content>
</sc-flex>
